<template>
  <v-card style="height: calc(100vh - 48px)">
    <v-card-text>
      <v-row class="mx-0">
        <v-col cols="2">
          <select-project
            v-model="project"
            :loading="isLoading"
          />
          <v-select
            v-model="searchBy"
            class="mt-2"
            label="Search by"
            :items="['login', 'account_id']"
            hide-details
          />
          <v-row>
            <v-col
              class="pb-0"
              cols="12"
            >
              <v-label>
                Fields to set
              </v-label>
            </v-col>
            <v-col cols="6">
              <v-checkbox
                class="mt-0 pt-0"
                label="Autobonus"
                hide-details
                @change="toggleField($event, AUTOBONUS, false)"
              />
            </v-col>
            <v-col cols="6">
              <v-checkbox
                class="mt-0 pt-0"
                label="Vip Manager"
                hide-details
                @change="toggleField($event, VIP_MANAGER, null)"
              />
            </v-col>
          </v-row>
          <v-row v-if="isFormHasValues">
            <v-col
              cols="12"
              class="pb-0"
            >
              <v-label>
                Field values
              </v-label>
            </v-col>
            <v-col
              v-if="AUTOBONUS in form"
              cols="6"
              class="pt-0"
            >
              <v-checkbox
                v-model="form[AUTOBONUS]"
                label="Autobonus"
                hide-details
              />
            </v-col>
            <v-col
              v-if="VIP_MANAGER in form"
              cols="6"
              class="pt-0"
            >
              <v-select
                v-model="form[VIP_MANAGER]"
                :items="users"
                label="Vip Manager"
                item-text="name"
                item-value="user_id"
                hide-details
              />
            </v-col>
          </v-row>
          <v-row class="mx-0 justify-end">
            <v-btn
              v-if="accounts.length"
              icon
              color="error"
              :loading="isLoading"
              @click="accounts = []"
            >
              <v-icon>
                close
              </v-icon>
            </v-btn>

            <v-btn
              icon
              color="primary"
              :disabled="!accounts.length || !isFormHasValues"
              :loading="isLoading"
              @click="onEdit"
            >
              <v-icon>
                check
              </v-icon>
            </v-btn>
          </v-row>
        </v-col>
        <v-col cols="10">
          <template v-if="!accounts.length">
            <v-textarea
              v-model="rawAccounts"
              label="Accounts"
              auto-grow
              class="accounts-list-textarea"
              :hint="`One ${searchBy} per line, click confirm when data is correct`"
            />
            <v-btn
              class="mt-2 ml-auto"
              color="primary"
              @click="onRawDataConfirm"
            >
              Confirm
            </v-btn>
          </template>

          <v-data-iterator
            v-else
            dense
            :items="accounts"
            :footer-props="{ 'items-per-page-options': [50, 100, -1] }"
            :items-per-page="50"

          >
            <template v-slot:header>
              <h3>Search Term</h3>
            </template>


            <template v-slot:default="{items}">
              <v-row  style="max-height: calc(100vh - 160px); overflow-y: auto;">
                <v-col
                  v-for="item in items"
                  :key="item.search_term"
                  cols="12"
                  sm="6"
                  md="3"
                  lg="2"
                >
                  <v-text-field
                    v-model="item.search_term"
                    style="max-width: 15rem;"
                    class="my-2"
                    hide-details
                    dense
                  />
                </v-col>
              </v-row>
            </template>

          </v-data-iterator>
        </v-col>
      </v-row>
    </v-card-text>

    <v-dialog
      v-model="resultDialog"
      max-width="1200"
    >
      <v-data-table
        :items="affectedAccounts"
        :headers="resultHeaders"
      />
    </v-dialog>
  </v-card>
</template>

<script>
import SelectProject from '@/components/core/SelectProject/SelectProject.vue'

// TODO: make generic config if more fields are needed later on
const AUTOBONUS = 'autobonus'
const VIP_MANAGER = 'vip_manager'

export default {
  components: {
    SelectProject,
  },
  props: {
    isLoading: Boolean,
    users: {
      type: Array,
      required: true,
    },
    affectedAccounts: {
      type: Array,
      required: true,
    },
  },
  emits: ['edit'],
  data() {
    return {
      searchBy: 'login',
      rawAccounts: '',
      accounts: [],
      project: null,
      form: {},
      resultDialog: false,
      resultHeaders: [
        { text: 'ID', value: 'account_id' },
        { text: 'Login', value: 'login' },
        { text: 'Autobonus', value: 'data.promo.autobonus' },
        { text: 'VIP Manager', value: 'data.vip_manager' },
      ],

      AUTOBONUS,
      VIP_MANAGER,
    }
  },
  computed: {
    isFormHasValues() {
      return Object.keys(this.form).length !== 0
    }
  },
  methods: {
    onRawDataConfirm() {
      this.accounts = this.rawAccounts.split('\n').filter(Boolean).map(search_term => ({ search_term }))
    },

    onEdit() {
      this.$emit('edit', {
        project: this.project,
        accounts: this.accounts.map(({search_term}) => search_term),
        form: this.form,
        search_by: this.searchBy
      })
    },

    toggleField(isEnabling, field, defaultValue) {
      if (isEnabling) {
        this.$set(this.form, field, defaultValue)
      } else {
        this.$delete(this.form, field)
      }
    }
  },

  watch: {
    affectedAccounts(newList) {
      this.resultDialog = newList.length !== 0
    }
  }
}
</script>
